// Copia este archivo a tu app frontend (React, Vue, HTML plano, lo que sea)
// e inicialízalo una sola vez, lo antes posible (ej. en tu main.js / index.js / App.tsx).
//
//   import { createErrorHub } from "./error-hub-browser";
//   const errorHub = createErrorHub({
//     apiKey: "LA_API_KEY_DE_ESTA_APP", // la copias desde /setup en Phrourós
//     origin: "https://panel3r2ores.atiktechmx.com", // o http://localhost:3000 en desarrollo
//   });
//
// Con eso ya capturas automáticamente:
//   - errores no manejados (window.onerror)
//   - promesas rechazadas sin catch (unhandledrejection)
//
// Para capturar errores que tú mismo atrapas en un try/catch:
//   try { ... } catch (err) { errorHub.capture(err, { userId, accion: "checkout" }); }
//
// Para mandar advertencias que no son errores fatales:
//   errorHub.warn("El pago tardó más de 5s", { orderId });

export function createErrorHub({ apiKey, origin }) {
  function send(message, level, stack, context) {
    fetch(`${origin}/api/errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "x-api-key": apiKey },
      body: JSON.stringify({ message, level, stack, context }),
      keepalive: true, // para que el POST llegue aunque la página se esté cerrando
    }).catch(() => {});
  }

  if (typeof window !== "undefined") {
    window.addEventListener("error", (event) => {
      send(event.message, "ERROR", event.error?.stack, { url: location.href });
    });

    window.addEventListener("unhandledrejection", (event) => {
      const reason = event.reason;
      const err = reason instanceof Error ? reason : new Error(String(reason));
      send(err.message, "ERROR", err.stack, { url: location.href });
    });
  }

  return {
    capture(error, context) {
      const err = error instanceof Error ? error : new Error(String(error));
      send(err.message, "ERROR", err.stack, context);
    },
    warn(message, context) {
      send(message, "WARNING", undefined, context);
    },
    info(message, context) {
      send(message, "INFO", undefined, context);
    },
  };
}
